"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SystemProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _PaletteConfigProvider = require("./palette/PaletteConfigProvider");
var _ScaleProvider = require("./scale/ScaleProvider");
var _SpectrumProvider = require("./spectrum/SpectrumProvider");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const SystemProvider = /*#__PURE__*/(0, _react.memo)(({
  scale,
  spectrum,
  palette,
  children
}) => {
  return /*#__PURE__*/_react.default.createElement(_ScaleProvider.ScaleProvider, {
    value: scale
  }, /*#__PURE__*/_react.default.createElement(_SpectrumProvider.SpectrumProvider, {
    value: spectrum
  }, /*#__PURE__*/_react.default.createElement(_PaletteConfigProvider.PaletteConfigProvider, {
    value: palette
  }, children)));
});
exports.SystemProvider = SystemProvider;
SystemProvider.displayName = 'SystemProvider';